import * as styles from "./SectionWrapper.module.scss";
import * as React from "react";

type SectionWrapperProps = { children: React.ReactNode };
export const SectionWrapper = (props: SectionWrapperProps): JSX.Element => {
  return <div className={styles.sectionWrapper}>{props.children}</div>;
};
